import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { Button, Link } from "@gemini/ui";
import { useTranslate } from "../../../utils/useTranslate";
import { BRAND_CONFIGURATION } from "../../../../configs/brands";
export const NotFoundErrorPageButtons = () => {
    const t = useTranslate();
    return (_jsxs(Box, { paddingHorizontal: { "breakpoint.base": "spacing.16" }, display: "inline-flex", flexDirection: "column", alignItems: "center", alignSelf: "stretch", gap: "spacing.12", children: [_jsx(Button, { variant: "primary", href: "/", isFullWidth: {
                    "breakpoint.base": true,
                    "breakpoint.sm": false,
                }, children: t("notFoundError.primaryButton") }), BRAND_CONFIGURATION.errorEmailAddress && (_jsx(Link, { href: `mailto:${BRAND_CONFIGURATION.errorEmailAddress}`, children: t("notFoundError.secondaryButton") }))] }));
};
